<template>
  <div>
    <Form
      ref="form"
      class="RealisationDetail PageWrapper DetailGrid"
      @error="handleValidationError"
      @submit="handleSubmit"
    >
      <RealisationHeader
        :feedback="feedback"
        :feedback-message="feedbackMessage"
        :step="currentStep"
        :record-step="step"
        :record="record"
      >
        <b-button
          variant="outline-light"
          class="ml-3"
          size="sm"
          type="submit"
          :disabled="disabled"
          @click.prevent.stop="handlePrevious"
        >
          Vorige stap
        </b-button>

        <template v-if="! locked">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
          >
            Opslaan
          </b-button>
          <b-button
            v-if="step !== currentStep"
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleCancelChange"
          >
            Annuleren
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleSubmitAndNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else-if="mayEdit">
          <!-- <b-button v-if="openForChange" variant="outline-light" class="ml-3" size="sm" type="submit" :disabled="disabled"
            @click.prevent.stop="handleStartChange">
            Wijzigen
          </b-button> -->
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || step <= currentStep"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>
      </RealisationHeader>

      <RealisationSidebar :uuid="uuid" />

      <div
        v-if="! reloading"
        class="DetailGrid__map"
      >
        <DateOfCommissioning
          :values="values"
          :disabled="locked || disabled"
        />

        <!-- <h3>Maillijst</h3>
        <p>Status: Todo</p>
        <b-button>
          Stuur email
        </b-button> -->
      </div>

      <RealisationFooter
        :feedback="feedback"
        :feedback-message="feedbackMessage"
      >
        <b-button
          variant="outline-light"
          class="ml-3"
          size="sm"
          type="submit"
          :disabled="disabled"
          @click.prevent.stop="handlePrevious"
        >
          Vorige stap
        </b-button>

        <template v-if="! locked">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
          >
            Opslaan
          </b-button>
          <b-button
            v-if="step !== currentStep"
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleCancelChange"
          >
            Annuleren
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleSubmitAndNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else-if="mayEdit">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleStartCorrection"
          >
            Corrigeren
          </b-button>
          <b-button
            v-if="openForChange"
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleStartChange"
          >
            Wijzigen
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || step <= currentStep"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>
      </RealisationFooter>
    </Form>
    <Comments :record="record" />
  </div>
</template>

<script>

import RealisationHeader from '@/components/realisation/RealisationHeader'
import RealisationFooter from '@/components/realisation/RealisationFooter'
import RealisationSidebar from '@/components/realisation/RealisationSidebar'

import Form from '@/components/form/Form'

import DateOfCommissioning from '@/components/definitions/DateOfCommissioning'

import Comments from '@/components/Comments'

import BaseRealisationStep from '@/views/BaseRealisationStep'

export default {
  name: 'RealisationStep8',
  components: {
    RealisationSidebar, RealisationHeader, RealisationFooter,
    Form, Comments,
    DateOfCommissioning,
  },
  mixins: [BaseRealisationStep],
  data() {
    return {
      currentStep: 8,
    }
  },
  created() {
    // console.log("step 8")
    // console.log(this.record)
    // console.log(this.values)
  },
  methods: {
    prepData({ data }) {
      return data
    },
    isValidData({ data }) {
      if (this.goingToNextStep) {
        try {
          if (
            data.DateOfCommissioning.DateOfCommissioning === ''
          ) {
            throw new Error('')
          }
        } catch (e) {
          this.disabled = false
          this.feedback = 'danger'
          this.feedbackMessage = 'Het proces kan niet verder zonder een datum van inbedrijfstelling.'
          return false
        }
      }

      return true
    },
  },
}
</script>
